// extracted by mini-css-extract-plugin
export default {"tooltip":"_2PzqC4EbeGG6sqYgRsTqMF","tooltipClose":"_2VGKUlxoq-Q0U6HOvcsnUU"};